import React from 'react'

const Nofound404 = () => {
  return (
    <div>404</div>
  )
}

export default Nofound404